export const IGNORED_BREADCRUMB_PATHS = ["products", "landingpages", "configuration"];
